export const REPORT = `/report/` as const
// export const REPORT_ALL = `${REPORT}all` as const
export const REPORT_LIST = `${REPORT}` as const
export const REPORT_MISCONDUCT_LIST = `${REPORT}` as const
export const REPORT_MISCONDUCT_PANEL = `${REPORT}` as const
export const REPORT_FIELDS = `${REPORT}fields` as const
export const REPORT_FIELDS_FILTER = `${REPORT_FIELDS}/filter` as const
